import {
    Button,
    Modal,
    TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { LoaderScreen } from "../../../components/LoaderScreen";

export const ModalComentarios = ({
    open,
    handleCloseModal,
    idcliente,
}) => {
    const [nuevoComentario, setNuevoComentario] = useState('');
    const [comentarios, setComentarios] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleTextChange = (event) => {
        setNuevoComentario(event.target.value); 
    };

    const handleAddComentario = () => {
        console.log(idcliente, nuevoComentario)
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ComentariosClientesContacto/Guardar?idcliente=${idcliente}&comentario=${nuevoComentario}`)
            .then((response) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "Éxito",
                    "El comentario se ha guardado correctamente.",
                    "success"
                );
                handleCloseModal();
            })
            .catch((error) => {
                console.error(error);
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "Error",
                    "Ocurrió un error al guardar el comentario.",
                    "error"
                );
            });
    };
    

    useEffect(() => {
        request
            .get(`ComentariosClientesContacto/Mostrar?idcliente=${idcliente}`)
            .then((result) => {
                setComentarios(result);
            })
            .catch((error) => {
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    }, [idcliente]);

    return (
        <Modal open={open} onClose={handleCloseModal}>
            <div className="dash-clientes-credito-crear-solicitud-modal">
                <LoaderScreen loader={loader} />
                <div className="credito-agregar-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>COMENTARIOS</h3>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>
    
                <div className="comentarios-container">
                    {comentarios === undefined || comentarios === null || comentarios.length === 0 ? (
                        <div></div>
                    ) : (
                        <table>
                            <thead></thead>
                            <tbody>
                                {comentarios.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.comentarios}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
    
                <TextField
                    id="comentarios"
                    label="Comentarios"
                    multiline
                    rows={3}
                    sx={{ mb: 2, width: 540 }}
                    value={nuevoComentario} // Usa el estado nuevoComentario para el valor del campo de texto
                    onChange={handleTextChange} // Maneja los cambios de texto
                />
    
                <div className="credito-crear-tasa-interes-modal-button-container">
                    <Button onClick={handleCloseModal} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button onClick={handleAddComentario} variant="contained">
                        Guardar
                    </Button>
                </div>
            </div>
        </Modal>
    );    
};
